import { Box, Button, Card, CardContent, Chip, Grid, IconButton, Stack, Typography } from "@mui/material";
import React, { useEffect, useRef, useState } from "react";
import ClearIcon from "@mui/icons-material/Clear";
import CopyToClipboard from "react-copy-to-clipboard";
import ContentCopyIcon from "@mui/icons-material/ContentCopy";
import { DYNAMIC_URL_REGEX } from "../../../../constants";
import { MediaDisplay } from "./MediaDisplay";


export default function MediaPreview({
    type,
    url,
    deleteFile,
    height,
    formikImage,
    isDisabled,
}) {
    const supportedImageMimeTypeArray = ["image/jpeg", "image/png", "image/jpg"];


    useEffect(() => {
    }, [url]);



    const onClickDeleteFile = () => {
        deleteFile();
    };

    return (
        <Grid>

            {type == "application/pdf" || formikImage?.type === "application/pdf" ? (
                <MediaDisplay
                    mediaUrl={formikImage?.url}
                    fileName={formikImage?.fileName}
                    handleRemoveMedia={deleteFile}
                    disabled={Boolean(isDisabled)}
                />
            ) :
                url !== null || formikImage?.url ? (
                    <Box display={"flex"} alignItems={"flex-start"}>
                        <Card style={{ padding: "0px", marginBottom: "10px" }}>
                            <CardContent
                                sx={{
                                    display: "flex",
                                    flexDirection: "column",
                                    gap: "10px",
                                    paddingLeft: "10px",
                                    paddingRight: "0px",
                                }}
                            >
                                <Grid sx={{ alignItems: "center", textAlign: "end" }}>
                                    {!isDisabled ? (
                                        <IconButton size="large" style={{ margin: "0px" }} onClick={() => onClickDeleteFile()}>
                                            <ClearIcon className="text-danger " />
                                        </IconButton>
                                    ) : (
                                        <Button startIcon={<ContentCopyIcon />} variant="outlined" size="medium">
                                            <CopyToClipboard text={formikImage?.url}>
                                                <span>Copy Url</span>
                                            </CopyToClipboard>
                                        </Button>
                                    )}
                                </Grid>

                                <Grid className="p-1 border">


                                    {formikImage?.url && formikImage?.url.match(DYNAMIC_URL_REGEX) ?
                                        <ImageUrlDisplay formikImage={formikImage} />
                                        :
                                        <>{supportedImageMimeTypeArray.includes(type) || supportedImageMimeTypeArray.includes(formikImage?.type) ? (
                                            <>
                                                <img
                                                    src={formikImage?.url}
                                                    style={{ objectFit: "cover", maxWidth: "500px", maxHeight: height ?? "500px" }}
                                                    alt=""
                                                />

                                            </>
                                        ) : type == "image/gif" || formikImage?.type === "image/gif" ? (
                                            <>
                                                <img width={"438px"} height={"146px"} src={formikImage?.url} style={{ objectFit: "contain" }} alt="gif" />
                                            </>
                                        ) : type == "application/pdf" || formikImage?.type === "application/pdf" ? (
                                            <>
                                                <MediaDisplay
                                                    mediaUrl={formikImage?.url}
                                                    fileName={formikImage?.fileName}
                                                    handleRemoveMedia={deleteFile}
                                                    disabled={Boolean(isDisabled)}
                                                />
                                            </>
                                        ) : (
                                            (type === "video/mp4" || formikImage?.type === "video/mp4") &&


                                            <Grid display={"flex"} justifyContent={"center"} flexDirection={"column"} alignItems={"center"}>
                                                <video width="350" height="150" controls>
                                                    <source src={formikImage?.url} type={type ?? formikImage?.type} />
                                                </video>
                                                <Grid display={"flex"} alignItems={"center"}></Grid>
                                            </Grid>

                                        )



                                        }</>}
                                </Grid>
                            </CardContent>
                        </Card>
                    </Box>
                ) : (
                    <></>
                )}
        </Grid>
    );
}




export const ImageUrlDisplay = ({ formikImage }) => {
    // Extract variables from URL in a more readable way
    const extractVariables = (url) => {
        if (!url) return [];

        const matches = url.match(/\[([a-zA-Z0-9_]+)\]/g) || [];
        return matches.map(match => match.slice(1, -1));
    };

    const variables = extractVariables(formikImage?.url);

    if (!formikImage?.url) {
        return (
            <Typography variant="body2" color="textSecondary">
                No image URL provided
            </Typography>
        );
    }

    return (
        <Box sx={{ p: 2 }}>
            {/* Image URL Display */}
            <Typography className='mt-3' >
                <b className='text-dark m-1'>
                    URL
                </b>
            </Typography>
            <Typography
                variant="body2"
                sx={{
                    wordBreak: 'break-all',
                    backgroundColor: 'grey.100',
                    p: 1,
                    borderRadius: 1,
                    fontFamily: 'monospace',
                    mb: 2
                }}
            >
                {formikImage.url}
            </Typography>

            {/* Variables Section */}
            {variables.length > 0 && (
                <>
                    <Typography className='mt-3' >
                        <b className='text-dark m-1'>
                            Variables used in URL ({variables.length})
                        </b>
                    </Typography>
                    <Stack direction="row" spacing={1} flexWrap="wrap">
                        {variables.map((variable, index) => (
                            <Chip
                                key={`${variable}-${index}`}
                                label={variable}
                                variant="outlined"
                                size="small"
                                sx={{ mb: 1 }}
                            />
                        ))}
                    </Stack>
                </>
            )}

            {variables.length === 0 && (
                <Typography variant="body2" color="textSecondary">
                    No variables found in URL
                </Typography>
            )}
        </Box>
    );
};
